import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { RulePartitionBase } from './rule-partition-base';
import { AppConstants, JsonHelper, BaseComponent } from '../util/index';
import { Logger } from '../services/logger.service';
import { CacheService } from '../services/cache.service';
import { HttpService } from '../services/http.service';
import { NotificationService } from '../services/notification.service';
import { ResponseJson, PartitionDefinition, PartitionDataDetails, PartitionExportHistory, RuleDefinition, RangeNDC, Premium } from '../models/index';
import { ActionName } from 'app/shared/constants';
import { SortMeta } from 'primeng/api';
import { FilterList } from 'app/mobileid-data/mobileid-data.downloader';
import { Table } from 'primeng/table';
import { FilterBy } from 'app/filter/filter-service';


@Component({
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.scss'],
  standalone: false
})
export class RulesComponent extends RulePartitionBase implements OnInit {
  ruleDef: RuleDefinition = new RuleDefinition();
  showResult = false;
  showFilterBy = true;
  dpTypes: any[] = [];
  partitionSelection: PartitionDefinition[];
  iprnCols: any[];
  rangeCols: any[];
  tableCols: any[] = [];
  filterFieldCols: any[] = [];
  actionNameFilter: ActionName = ActionName.CreateRuleRangeFilter;
  @ViewChild('rangeOverlay') rangeOverlay: ElementRef;
  @ViewChild('dt') dt: ElementRef;

  dataTotalCount: number;
  saveEvent: any;
  searchPattern: string;
  multiSortMeta: SortMeta[];

  lastQueryId = 0;
  lastResponseId = 0;
  saveTs: number;



  constructor(public log: Logger, public httpService: HttpService, public cacheService: CacheService, public notifService: NotificationService) {
    super(log, httpService, cacheService, notifService);

    this.iprnCols = [
      { field: 'dialPatternType', header: 'Prime', width: '50px' },
      { field: 'dialPattern', header: 'DialPattern', width: '50px' },
      { field: 'code', header: 'Code', width: '30px' },
      { field: 'ndc', header: 'NDC', width: '30px' },
      { field: 'iso2', header: 'ISO2', width: '30px' },
      { field: 'termCountry', header: 'Country', width: '50px' },
      { field: 'tos', header: 'TOS', width: '30px' },
      { field: 'tosdesc', header: 'TOS Description', width: '75px' },
      { field: 'supplement', header: 'Supplement', width: '100px' },
      { field: 'provider', header: 'Provider', width: '75px' },
      { field: 'lemin', header: 'LEMin', width: '62px' },
      { field: 'lemax', header: 'LEMax', width: '64px' },
      { field: 'lastSeen', header: 'Last Seen', width: '50px' }
      // { field: 'lastUpdate', header: 'Last Observed', width: '80px' }
    ];

    this.rangeCols = [
      { field: 'dialPattern', header: 'DialPattern', width: '50px' },
      { field: 'code', header: 'Code', width: '30px' },
      { field: 'ndc', header: 'NDC', width: '30px' },
      { field: 'iso2', header: 'ISO2', width: '30px' },
      { field: 'termCountry', header: 'Country', width: '50px' },
      { field: 'tos', header: 'TOS', width: '30px' },
      { field: 'tosdesc', header: 'TOS Description', width: '75px' },
      { field: 'supplement', header: 'Supplement', width: '100px' },
      { field: 'provider', header: 'Provider', width: '75px' },
      { field: 'lemin', header: 'LEMin', width: '62px' },
      { field: 'lemax', header: 'LEMax', width: '64px' },
      { field: 'effectiveDate', header: 'Effective Date', width: '75px' },
    ];

    this.tableCols = [...this.rangeCols];
    this.tableCols.forEach(c => {
      this.filterFieldCols.push(c.field);
    });

  }

  ngOnInit() {
    super.init();
    this.dpTypes.push({ label: 'PRIME',   value: 'PRIME' });
    this.dpTypes.push({ label: 'PRIME-1', value: 'PRIME-1' });
    this.dpTypes.push({ label: 'PRIME-2', value: 'PRIME-2' });
    this.dpTypes.push({ label: 'PRIME-3', value: 'PRIME-3' });
    this.dpTypes.push({ label: 'PRIME-4', value: 'PRIME-4' });
    this.showResult = false;
    this.isCreateRule = true;
    this.getPartitionList(null, ActionName.CreateRule);
    this.ruleDef = new RuleDefinition();
    this.ruleDef.dataSource = 'Range';
    this.dataSource = this.ruleDef.dataSource;
  }

  newRule() {
    super.init();
    this.dpTypes = [];
    this.partitionSelection = [];
    this.ngOnInit();
  }

  saveRule() {
    this.createRangeFilter();

    if (this.ruleDef.dataSource === 'Range' && !this.rangeFilter.hasDefinedAnyFilter()) {
      this.notifService.add({ severity: 'error', summary: 'Error', detail: 'You must select at least one filter value in order to save a Range rule' });
      return false;
    }

    this.ruleDef.details = this.rangeFilter;

    this.log.debug(JsonHelper.toJson(this.ruleDef));

    this.httpService.post(JsonHelper.toJson(this.ruleDef), AppConstants.CreateRuleURL, [this.postCreateRuleHandler, this.responseCallBack]);
  }

  postCreateRuleHandler = (responseJson: ResponseJson) => {
    if (responseJson.status === AppConstants.SUCCESS) {
      this.newRule();
    }
  }

  assignPartition(selectedPartitions: PartitionDefinition[]) {
    console.log("Selected=" + selectedPartitions.length, selectedPartitions);

    this.ruleDef.partitions = [];



    selectedPartitions.forEach(p => {
      if (p.ruleDefinitions && p.ruleDefinitions.length === 50) {
        this.notifService.add({ severity: 'warn', summary: 'Info', detail: 'Partitions can have a maximum of 50 rules. ' + p.name + ' cannot be selected.' });
        const index = JsonHelper.findElementPosById(selectedPartitions, p.id);
        if (index >= 0) {
          selectedPartitions.splice(index);
        }
      } else {
        this.ruleDef.addPartition(p);
      }
    });
  }


  // closeAllFilter() {
  //   $('.filter').hide(); 
  //   // this.fetchRangeData(this.actionNameFilter,false, this.ruleDef);
  //   this.showResult = true;
  //   // this.stopFetching();
  // }


  applyFilter(dt: Table) {
    dt.reset();
    this.loadDataDetails({ ...this.saveEvent, first: 1 });
  }


  cancelFilterUpdate() {
    $('.filter').hide();
    this.showResult = true;
  }


  async selectDataSource(event: any) {
    if (event.currentTarget.checked) {
      this.ruleDef.dataSource = 'IPRN';
      this.tableCols = [...this.iprnCols];
      this.actionNameFilter = ActionName.CreateRuleIprnFilter;
    } else {
      this.ruleDef.dataSource = 'Range';
      this.tableCols = [...this.rangeCols];
      this.actionNameFilter = ActionName.CreateRuleRangeFilter;
    }
    this.dataSource = this.ruleDef.dataSource;
    if (this.dataSource === 'Range') {
      this.ruleDef.dialPatternType = null;
      this.ruleDef.noOfMonth = undefined;
      this.rangeFilter.numOfMonthsSinceLastObserved = undefined;
      this.ruleDef.noOfDays = undefined;
      this.rangeFilter.numOfDaysSinceLastSeen = undefined;
    } else {
      this.ruleDef.dialPatternType = 'PRIME';
    }
    this.tableCols.forEach(c => {
      this.filterFieldCols.push(c.field);
    });
    this.stopBatchLoading = true;
    await AppConstants.delay(1000);
    //Send an empty action because we dont want to log an action every time for selection of toggle
    this.loadDataDetails({ ...this.saveEvent, first: 0, multiSortMeta: [] });
    this.showResult = true;
  }

  async selectDialPattern(event) {
    this.ruleDef.dialPatternType = event.value;
    // this.stopBatchLoading = true;
    // await AppConstants.delay(1000);
    // this.fetchRangeData(this.actionNameFilter,false, this.ruleDef);
    this.loadDataDetails({ ...this.saveEvent, first: 0, multiSortMeta: [] });
    this.showResult = true;
  }

  openFilterInRules(name: FilterBy) {
    this.showResult = true;
    this.openFilter(name);
  }

  openRangeOverlay(panelNum: number, filterBy: FilterBy, event: any) {
    const overlay = this.rangeOverlay as any;
    this.patchOverlayAlign(overlay);
    const switchingPanels = overlay.overlayVisible && this.selectedPanel !== panelNum;
    this.togglePanel(panelNum);
    this.showResult = false;
    this.openFilterInRules(filterBy);
    if (switchingPanels) {
      overlay.show(event);
      overlay.align();
    } else {
      overlay.toggle(event);
    }
  }

  /**
   * PrimeNG 21's align() uses getBoundingClientRect() to read the container's left position,
   * but at onAnimationStart the enter animation has transform:scale(0.93) applied, which shifts
   * the reported left by ~(containerWidth * 0.035). This causes the arrow to point to the wrong
   * card for non-leftmost buttons. Fix: read the actual CSS insetInlineStart value that
   * absolutePosition() just set, which is unaffected by transforms.
   */
  private patchOverlayAlign(overlay: any): void {
    if (overlay._alignPatched) return;
    overlay._alignPatched = true;
    const origAlign = overlay.align.bind(overlay);
    overlay.align = function() {
      origAlign();
      if (this.container && this.target) {
        const containerLeft = parseFloat(this.container.style.insetInlineStart) ||
                              parseFloat(this.container.style.left) || 0;
        const targetRect = (this.target as HTMLElement).getBoundingClientRect();
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || 0;
        const targetLeft = targetRect.left + scrollLeft;
        const borderRadius = parseFloat(
          (document.defaultView || window).getComputedStyle(this.container).getPropertyValue('border-radius')
        ) || 0;
        let arrowLeft = 0;
        if (containerLeft < targetLeft) {
          arrowLeft = targetLeft - containerLeft - borderRadius * 2;
        }

        if (arrowLeft <= 0) 
            arrowLeft = 162;
        else 
          arrowLeft -=160;  

        this.container.style.setProperty('--p-popover-arrow-left', `${arrowLeft}px`);
      }
    };
  }


  loadDataDetails(event) {

    if (JSON.stringify(this.saveEvent) === JSON.stringify(event) && (Date.now() - this.saveTs) < 1000)
      return;


    const { first, rows, multiSortMeta, globalFilter } = event;

    console.log("+++ loadDataDetails:", Date(), event, multiSortMeta, rows);

    const pageNo = first / rows;
    // this.pageNo = pageNo;
    // this.limit = rows;
    this.multiSortMeta = multiSortMeta;
    this.searchPattern = globalFilter;
    this.saveEvent = event;
    this.saveTs = Date.now();

    this.pagination(pageNo, rows, multiSortMeta, globalFilter, () => { });
  }


  pagination(page, limit, sortMeta: SortMeta[], globalFilter, func) {
    this.filteredRangeDataList = [];
    this.dataTotalCount = undefined;


    let orderBy = sortMeta ? sortMeta.map(s => { return { property: this.mapSortField(s.field), dir: s.order == 1 ? 'ASC' : 'DESC' } }) : null;
    // , 
    const pageParams = {
      page: page,
      size: limit,
      orderBy: orderBy
    }


    const filterParams: FilterList = this.makeFilter(globalFilter, this.ruleDef.dialPatternType ? this.ruleDef.dialPatternType : null);

    const body = {
      filter: filterParams,
      page: pageParams,
      lastQueryId: ++this.lastQueryId,

    }



    if (this.dataSource == 'IPRN') {
      this.tableCols = [...this.iprnCols];
      this.httpService.post(JSON.stringify(body), AppConstants.QueryFilteredPremiumPageURL,
        [this.postQueryDataHandler]);
    } else {
      this.httpService.post(JSON.stringify(body), AppConstants.QueryFilteredRangePageURL,
        [this.postQueryDataHandler]);
    }
  }
  mapSortField(field: string): string {
    if (field == 'dialPattern')
      return this.ruleDef.dataSource == 'IPRN' ? 'dialPattern' : 'ccNdc';

    return field;
  }

  postQueryDataHandler = async (responseJson: ResponseJson) => {
    console.info('in postQueryDataHandler 1', Date());

    if (responseJson.status != AppConstants.SUCCESS) {
      console.error("response error:", responseJson.message);
    }

    if (responseJson.lastQueryId != this.lastQueryId) {
      console.warn("We ignore earlier response", responseJson.lastQueryId, " != ", this.lastQueryId);
      return;
    }
    else {
      this.lastResponseId = responseJson.lastQueryId;
    }


    if (responseJson.status === AppConstants.SUCCESS) {
      if (!responseJson.data) {
        console.warn('in postQueryDataHandler', Date(), responseJson.message, 'no-data');
        return;
      }

      const result: any = JsonHelper.parseArray(responseJson.data, Object);
      this.dataTotalCount = responseJson.totalCount;
      this.postProcessRuleItems(result, this.ruleDef);
      this.filteredRangeDataList = result;
      console.info('in postQueryDataHandler 2', Date(), this.filteredRangeDataList.length);
    }
  }




  makeFilter(globalFilter: string, primeType: string | null): FilterList {
    return {
      iso2list: this.rangeFilter.iso2List,
      tosList: this.rangeFilter.tosDescList,
      providerList: this.rangeFilter.providerList.map(p => p.provider),
      numOfDaysSinceLastSeen: this.rangeFilter.numOfDaysSinceLastSeen ? this.rangeFilter.numOfDaysSinceLastSeen : '0',
      searchPattern: globalFilter,
      primeType: primeType
    }
  }



  isLoading(): boolean {
    return this.lastQueryId != this.lastResponseId;
  }

  totalMessage(): string {
    let actual = this.dataTotalCount;

    return (this.hasFilterMid() ? "Filtered Records: " : "Total Records: ") + actual;

  }

  hasFilterMid(): boolean {
    return this.hasFilter() || !!this.searchPattern;
  }


}


